"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _formatCurrencyWithCode = _interopRequireDefault(require("../utils/formatCurrencyWithCode"));

var _default = (0, _createReactClass.default)({
  displayName: "FormattedCurrency",
  propTypes: {
    abbreviate: _propTypes.default.bool,
    abbreviateThreshold: _propTypes.default.number,
    currencyCode: _propTypes.default.string,
    precision: _propTypes.default.number,
    simplifyCurrency: _propTypes.default.bool,
    stripInsignificantZeros: _propTypes.default.bool,
    unit: _propTypes.default.string,
    useCurrencyCode: _propTypes.default.bool,
    value: _propTypes.default.number.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      stripInsignificantZeros: false,
      simplifyCurrency: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        abbreviate = _this$props.abbreviate,
        abbreviateThreshold = _this$props.abbreviateThreshold,
        value = _this$props.value,
        simplifyCurrency = _this$props.simplifyCurrency,
        stripInsignificantZeros = _this$props.stripInsignificantZeros,
        useCurrencyCode = _this$props.useCurrencyCode,
        options = (0, _objectWithoutProperties2.default)(_this$props, ["abbreviate", "abbreviateThreshold", "value", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode"]);

    if (simplifyCurrency && value % 1 === 0) {
      options.precision = 0;
    }

    if (useCurrencyCode) {
      options.unit = '';
      options.useCurrencyCode = true;
    }

    if (stripInsignificantZeros === false) {
      options.strip_insignificant_zeros = false;
    } else {
      options.strip_insignificant_zeros = true;
    }

    var wrapperAttributes = {};

    if (abbreviate && (typeof abbreviateThreshold !== 'number' || typeof abbreviateThreshold === 'number' && value >= abbreviateThreshold)) {
      wrapperAttributes.title = _I18n.default.formatCurrency(value, options);
      options.abbreviate = true;
      options.precision = 0;
    }

    var formattedNumber = _I18n.default.formatCurrency(value, options);

    var numberToRender = useCurrencyCode ? (0, _formatCurrencyWithCode.default)(formattedNumber, options.currencyCode) : formattedNumber;
    return _react.default.createElement("span", wrapperAttributes, numberToRender);
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/components/FormattedCurrency.js
// module id = 163
// module chunks = 5 6